import { Card, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Badges, P } from "../../../../AbstractElements";
import { Fragment } from "react";
import { VERTICAL_STYLE_LIST } from "../../../../Data/FormControl/MegaOptions";
import { VerticalStyleFormProp } from "../../../../Type/FormValidation";

const VerticalStyleForm = () => {
  return (
    <Form className="mega-vertical">
      <Row>
        {VERTICAL_STYLE_LIST.map(({ megaTitle, child }, index) => (
          <Fragment key={index}>
            <Col sm="12">
              <P className="mega-title m-b-5">{megaTitle}</P>
            </Col>
            {child.map(({ id, color, cardClass, name, badgeTitle, mediaBodyClass, digits, spanText, check, spanClass, star }: VerticalStyleFormProp) => (
              <Col sm="6" key={id}>
                <Card className={cardClass}>
                  <div className="d-flex p-20">
                    <FormGroup className={`radio radio-${color} m-0 w-100`} check>
                      <Input id={`radios${id}`} type="radio" name={name} value="option1" defaultChecked={check} />
                      <Label className="mb-0 w-100" htmlFor={`radios${id}`} check>
                        <span className={`flex-grow-1 ${mediaBodyClass}`}>
                          <span className="mt-0 mega-title-badge">
                            {badgeTitle}
                            <Badges color={color} className="pull-right digits">
                              {digits}
                            </Badges>
                          </span>
                          <span className={spanClass}>
                            {star && star.map(({ id, starClass }) => <i key={id} className={`icofont icofont-star ${starClass}`}></i>)}
                            {spanText}
                          </span>
                        </span>
                      </Label>
                    </FormGroup>
                  </div>
                </Card>
              </Col>
            ))}
          </Fragment>
        ))}
      </Row>
    </Form>
  );
};

export default VerticalStyleForm;
